import api from './api';

export interface AdminChatResponse {
  content: string;
  tool_calls: Array<{
    tool_name: string;
    arguments: string;
    result: string;
    duration_ms: number;
  }>;
  session_id: string;
}

export interface AdminTool {
  name: string;
  summary: string;
  description: string;
}

export async function sendAdminChatMessage(
  content: string,
  modelId?: string,
): Promise<AdminChatResponse> {
  const response = await api.post('/admin/chat/messages', {
    content,
    model_id: modelId,
  }, { timeout: 120000 });
  return response.data;
}

export async function getAdminChatMessages(): Promise<{
  messages: Array<{ role: string; content: string; tool_calls?: any[] }>;
  session_id: string;
}> {
  const response = await api.get('/admin/chat/messages');
  return response.data;
}

export async function resetAdminChat(): Promise<void> {
  await api.post('/admin/chat/reset');
}

export async function getAdminChatTools(): Promise<AdminTool[]> {
  const response = await api.get('/admin/chat/tools');
  return response.data.tools;
}
